import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AiMyprDialogHeader',
  props: {
    catchText: { default: '' },
    title: null,
    lead: { default: '' },
    attention: { default: '' }
  },
  setup(__props: any) {

/**
 * 書式 AI mypr ダイアログのタイトルブロック（mypr-title-block）。
 */


return { __sfc: true, }
}

})